/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */

import { Routes, Route } from 'react-router-dom';
import ApplicationLayout from '../Layout';
import Intro from './Intro';
import Feedback from './Feedback';
import Error from './Error';

const coverStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  margin: 'initial',
};
export default function EWApplication() {
  return (
    <Routes>
      <Route
        index
        element={
          <ApplicationLayout type="ew" coverStyle={coverStyle}><Intro /></ApplicationLayout>
        }
      />

      <Route path="/error" element={<Error />} />
      <Route path="/feedback" element={<Feedback />} />
    </Routes>
  );
}
